import { toast } from 'react-toastify';

export function handleApiError(status, loadingToast, showToast, navigate = null, errorShownRef = { current: false }) {
  if (!showToast || errorShownRef.current) return;

  errorShownRef.current = true;
  const mensagens = {
    401: {
      render: "Sessão expirada, faça login novamente.",
      type: "error",
      callback: () => {
        localStorage.clear();
        if (navigate) navigate("/");
      }
    },
    403: {
      render: "Acesso negado.",
      type: "warn"
    },
    404: {
      render: "API não encontrado.",
      type: "warn"
    },
    default: {
      render: "Erro ao carregar camada.",
      type: "error"
    }
  };

  const { render, type, callback } = mensagens[status] || mensagens.default;

  if (loadingToast) {
    toast.update(loadingToast, {
      render,
      type,
      isLoading: false,
      autoClose: 500
    });
  } else {
    toast[type](render);
  }

  if (callback) callback();
}

